<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
      min-height: 62px;
    "
  >
    <div>
      <a :href="`/lead/${item.id}`" class="clickable-text">
        {{ item.phone }}
      </a>
    </div>
    <div>
      {{ item.email }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
}
</script>
